import React from 'react';
import PropTypes from 'prop-types';
/* eslint react/no-danger: 0 */
import { useLabels, usePrefs } from 'wsm-common-data';

const FacetTitle = ({ facetTitle, isCollapsed, groupId }) => {
	const labels = useLabels();
	const { facetDisplay } = usePrefs();
	const isAccordionDisplay = facetDisplay !== 'nested';
	const isGeoLocationEnabled = !!window.DDC?.InvData?.getGeoData();
	const isAccountId = groupId === 'accountId';

	const isShopByStore = isGeoLocationEnabled && isAccountId;

	const label = isShopByStore ? labels.get('SHOP_BY_STORE') : facetTitle;

	const createMarkup = () => {
		return { __html: `${label}` };
	};

	if (!isAccordionDisplay) {
		return (
			<span
				className={isShopByStore ? 'ddc-font-size-xsmall' : null}
				dangerouslySetInnerHTML={createMarkup()}
			/>
		);
	}

	const expandIcon = isCollapsed ? 'ddc-icon-expand' : 'ddc-icon-collapse';

	return (
		<span className="w-100 d-flex justify-content-between">
			<span
				className={
					isShopByStore
						? 'facet-list-group-label ddc-font-size-xsmall font-weight-normal text-decoration-none'
						: 'facet-list-group-label text-decoration-none'
				}
				dangerouslySetInnerHTML={createMarkup()}
			/>
			<i
				data-testid="expand-icon"
				className={`ddc-icon icon-style-collapse ${expandIcon}`}
				aria-hidden="true"
			/>
		</span>
	);
};

FacetTitle.propTypes = {
	facetTitle: PropTypes.string.isRequired,
	isCollapsed: PropTypes.bool,
	groupId: PropTypes.string
};

export default FacetTitle;
